<div class="loading" [class.is-done]="isDone">
  <div class="loading-backdrop"></div>

  <img class="plane-loader" src="/assets/as/39.webp" alt="Loading" />
</div>
